export default __webpack_public_path__ + "static/media/media.1f5e989c.svg";